/**退付手续费 */
import { $http, buildHeaders } from "./index";

//申诉管理
export const ptscommission_list = (params) => {
  return $http.get("/admin/PtsCommission/index", { params });
};

//获取操作记录
export const ptscommission_log = (params) => {
  return $http.get("/admin/PtsCommission/log", {
    params,
  });
};

//获取核对清册列表
export const ptscommission_gethdqc = (params) => {
  return $http.get("/admin/PtsCommission/getHdqclb", {
    params,
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//从税局更新数据
export const ptscommission_pull = (data) => {
  return $http.post("/admin/PtsCommission/pull", data, {
    headers: buildHeaders(3),
  });
};

//获取银行账户
export const ptscommission_getyhzh = (params) => {
  return $http.get("/admin/PtsCommission/getYhzhlb", {
    params,
  });
};

//确认核对全部
export const ptscommission_confirm = (data) => {
  return $http.post("/admin/PtsCommission/confirm", data, {
    headers: buildHeaders(3),
  });
};

//批量撤销申请
export const ptscommission_cancel = (data) => {
  return $http.post("/admin/PtsCommission/cancel", data, {
    headers: buildHeaders(3),
  });
};

//导出
export const ptscommission_export = (params) => {
  return $http.get("/admin/PtsCommission/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在生成文件，请稍后……"),
  });
};
